<template>
  <section>
    <section
      v-if="
        $store.state.loading_requests || $store.state.loading_request_detail
      "
      class="loader-container"
    >
      <Loader text="Cargando pedido" />
    </section>
    <v-card
      v-else
      flat
      :class="{
        urgent:
          currentTechReq &&
          currentTechReq.request &&
          currentTechReq.request.is_urgency,
      }"
    >
      <div
        v-if="!!fab"
        @click="fab = false"
        style="position: fixed; height: 100vh; width: 100vw"
        :class="{ overlay: fab }"
      ></div>
      <v-container class="bodypad">
        <v-row v-if="currentTechReq && currentTechReq.request">
          <div class="left-col" v-bind:class="{ hidden: fab }">
            <v-row>
              <!-- Urgency -->
              <v-col
                cols="12"
                style="color: #ff5252"
                v-if="
                  currentTechReq &&
                  currentTechReq.request &&
                  currentTechReq.request.is_urgency
                "
              >
                <b>PEDIDO URGENTE</b>
              </v-col>

              <!-- Visit Status -->
              <v-col
                v-if="
                  mobsUser &&
                  currentTechReq &&
                  currentTechReq.visit &&
                  currentTechReq.visit.length > 0
                "
                cols="12"
                class="d-flex"
                style="gap: 5px"
              >
                <v-chip
                  label
                  color="rapiblue"
                  text-color="white"
                  :class="{ dim: fab }"
                >
                  {{ currentVisit.visit_type.label }}
                </v-chip>
                <v-chip
                  label
                  color="rapiblue"
                  text-color="white"
                  :class="{ dim: fab }"
                >
                  {{ currentVisit.visit_status_name }}
                </v-chip>
              </v-col>

              <!-- Request Status -->
              <v-col v-else cols="12">
                <v-chip
                  label
                  color="rapiblue"
                  text-color="white"
                  :class="{ dim: fab }"
                >
                  {{ currentTechReq.request.status_request.description }}
                </v-chip>
              </v-col>

              <!-- Scheme Icon and Service name -->
              <v-col cols="12">
                <h3 class="d-flex align-center p-0 m-0">{{ mobsUser ? "Tipo de práctica" : "Tipo de servicio" }}</h3>
                <p style="text-transform: capitalize">
                  <template v-if="$store.state.app_display_scheme">
                    <img
                      v-if="currentTechReq.request.scheme === 'asistencia'"
                      class="icon-details mr-2"
                      src="../icons/asistencia.png"
                      height="20"
                      width="20"
                    />
                    <img
                      v-if="currentTechReq.request.scheme === 'cliente-final'"
                      class="icon-details mr-2"
                      src="../icons/clientefinal.png"
                      height="20"
                      width="20"
                    />
                    <img
                      v-if="currentTechReq.request.scheme === 'corpo'"
                      class="icon-details mr-2"
                      src="../icons/corporativo.png"
                      height="20"
                      width="20"
                    />
                    <img
                      v-if="currentTechReq.request.scheme === 'fletes'"
                      class="icon-details mr-2"
                      src="../icons/fletes.png"
                      height="20"
                      width="20"
                    />
                    <img
                      v-if="currentTechReq.request.scheme === 'inmobiliaria'"
                      class="icon-details mr-2"
                      src="../icons/inmobiliaria.png"
                      height="20"
                      width="20"
                    />
                    <img
                      v-if="currentTechReq.request.scheme === 'mobs'"
                      class="icon-details mr-2"
                      src="../icons/corporativo.png"
                      height="20"
                      width="20"
                    />
                  </template>
                  {{ currentTechReq.request.service.name }}
                </p>
              </v-col>

              <!-- Visit without confirmation || Visit in pending -->
              <v-col
                v-if="
                  !mobsUser && currentVisit && currentVisit.visit_status === 1
                "
                cols="12"
                md="12"
              >
                <p class="hidden-md-and-up mb-3">
                  <b v-if="currentVisit.visit_type.id === 4"
                    >Visita NO confirmada</b
                  >
                  <b v-else>Visita pendiente</b>
                </p>
                <v-chip
                  label
                  color="rapired"
                  text-color="white"
                  :class="{ dim: fab }"
                >
                  <span
                    v-if="currentVisit.visit_type.id === 4"
                    class="hidden-sm-and-down"
                    >Visita NO confirmada:
                  </span>
                  <span v-else class="hidden-sm-and-down"
                    >Visita pendiente:
                  </span>
                  <span
                    v-if="currentVisit"
                    style="
                      font-weight: bold;
                      margin-left: 6px;
                      text-transform: capitalize;
                    "
                  >
                    {{
                      currentVisit.visit_date &&
                      formatDate(currentVisit.visit_date)
                    }}, {{ currentVisit.arrival_time }} -
                    {{ currentVisit.departure_time }} hs
                  </span>
                </v-chip>
              </v-col>

              <!-- Visit in progress -->
              <v-col
                v-else-if="
                  !mobsUser && currentVisit && currentVisit.visit_status == 8
                "
                cols="12"
                md="12"
              >
                <v-chip
                  label
                  color="secondary"
                  text-color="white"
                  :class="{ dim: fab }"
                >
                  <span>Visita en curso</span>
                </v-chip>
              </v-col>

              <!-- Without visits -->
              <v-col
                v-else-if="
                  !mobsUser && currentTechReq.request.status_request.id != 13
                "
                cols="12"
                md="12"
              >
                <v-chip
                  v-if="mobsUser"
                  label
                  color="secondary"
                  text-color="white"
                  :class="{ dim: fab }"
                >
                  <span>La meeting no tiene visitas pendientes</span>
                </v-chip>
                <v-chip
                  v-else
                  label
                  color="secondary"
                  text-color="white"
                  :class="{ dim: fab }"
                >
                  <span>El pedido no tiene visitas pendientes</span>
                </v-chip>
              </v-col>

              <!-- Subsidiary information Cristopher -->
              <!-- <v-col
                v-if="mobsUser && currentTechReq.subsidiary"
                cols="12"
                class="req__list"
              >
                <h4 class="mb-2 ml-3">Cliente</h4>
                <p class="req__list_item">
                  {{ currentTechReq.subsidiary.full_name }}
                </p>
              </v-col> -->

              <!-- Client information -->
              <v-col
                v-if="!mobsUser && currentTechReq.request.client"
                cols="12"
                class="pb0"
              >
                <h4>Cliente</h4>
              </v-col>

              <v-col
                v-if="!mobsUser && currentTechReq.request.client"
                cols="12"
                class="pt0"
              >
                <p class="m0">
                  {{ currentTechReq.request.client.last_name }},
                  {{ currentTechReq.request.client.first_name }}
                </p>
              </v-col>

              <v-col
                v-if="!mobsUser && currentTechReq.request.client"
                cols="12"
                class="pt0"
              >
                <v-row
                  v-if="currentTechReq.request.client.full_cell_phone"
                  justify="space-between"
                  class="m0"
                >
                  <p class="m0">
                    {{ currentTechReq.request.client.full_cell_phone }}
                  </p>
                  <a
                    class="hidden-md-and-up"
                    :href="
                      'tel:' + currentTechReq.request.client.full_cell_phone
                    "
                    ><v-icon color="rapired" :class="{ dim: fab }"
                      >smartphone</v-icon
                    ></a
                  >
                </v-row>
              </v-col>

              <!-- Request description -->
              <v-col cols="12" class="req__list">
                <h4 class="mb-2 ml-3">{{ mobsUser ? "Descripción de la práctica" : "Descripción del servicio" }}</h4>
                <p class="req__list_item">
                  {{ currentTechReq.request.description }}
                </p>
              </v-col>

              <!-- Requirements -->
              <v-col
                v-if="mobsUser && requirementFilter && requirementFilter.length > 0"
                class="req__list"
              >
                <h4
                  class="mb-2 ml-3">Requisitos</h4>
                <p
                  v-for="(item, i) in requirementFilter"
                  :key="i"
                  class="req__list_item"
                >
                  <v-icon
                    color="success"
                    :class="{ dim: fab }"
                    >assignment_turned_in</v-icon
                  >
                  {{ item.question }}
                </p>
              </v-col>

              <!-- Address of the meeting  -->
              <v-col cols="12" class="pt0">
                <v-row class="m0">
                  <v-col class="req__list" v-for="item in currentTechReq.visit" :key="item.id">
                    <h4 v-if="mobsUser" style="color: #3a3a3a; font-size: 1rem">
                      Datos de la sucursal
                    </h4>
                    <v-row class="d-flex justify-space-around align-baseline">
                        <p
                          class="req__list_item"
                          style="text-transform: capitalize"
                        >
                        <span v-if="currentTechReq.request.same_address"> <b :class="{'success-text' : item.visit_status === 8 || item.visit_status === 1 }">Dirección Servicio:</b> {{ originAddress }}</span> 
                        <span v-else> <b :class="{'success-text' : item.visit_status === 1 }">Dirección Origen:</b> {{ originAddress }}</span>
                          <a
                            :href="googleMapsLinkClient"
                            target="_blank"
                            class=" ml-2"
                          >
                            <v-icon 
                              color="rapired" 
                              :class="{ dim: fab }"
                              class="mr-6"
                            >room</v-icon
                            >
                          </a>
                        </p>
                    </v-row>
                    <v-row v-if="!currentTechReq.request.same_address" class="d-flex justify-space-around align-baseline">
                        <p
                          class="req__list_item"
                          style="text-transform: capitalize"
                        >
                          <b :class="{'success-text' : item.visit_status === 8}">Dirección Destino:</b> {{ currentTechReq.request.address_request.full_address}}
                          <a
                            :href="googleMapsLink"
                            target="_blank"
                            class=" ml-2"
                          >
                            <v-icon 
                              color="rapired" 
                              :class="{ dim: fab }"
                              class="mr-6"
                            >room</v-icon
                            >
                          </a>
                        </p>
                    </v-row>
                  </v-col>
                  <!-- <v-col en mobile produce un alejamiento Cristopher
                    cols="2"
                    class="p0 icon-cont hidden-md-and-up"
                    align-self="center"
                  >
                    <a :href="googleMapsLink" target="_blank">
                      <v-icon color="rapired" :class="{ dim: fab }"
                        >room</v-icon
                      >
                    </a>
                  </v-col> -->
                </v-row>
              </v-col>

              <!-- Show visits -->
              <template v-if="showVisits">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" class="pa-0">
                      <h4 class="ml-3" style="font-size: 1rem; color: #3a3a3a">
                        {{ mobsUser ? "Servicio" : "Servicios" }}
                      </h4>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                      class="pb-0 visit"
                      v-for="item in currentTechReq.visit"
                      :key="item.id"
                    >
                      <div
                        class="d-flex align-center pa-3"
                        style="border-radius: 5px"
                        :class="{
                          highlighted:
                            item.visit_status === 1 ||
                            item.visit_status === 8 ||
                            item.visit_status === 12,
                          regular: item.visit_status !== 1,
                        }"
                      >
                        <v-icon
                          color="warning"
                          v-if="item.visit_status === 1"
                          :class="{ dim: fab }"
                          >event</v-icon
                        >
                        <v-icon
                          color="success"
                          v-if="
                            item.visit_status === 2 || item.visit_status === 14
                          "
                          :class="{ dim: fab }"
                          >check</v-icon
                        >
                        <v-icon
                          color="warning"
                          v-if="
                            item.visit_status === 3 || item.visit_status === 4
                          "
                          :class="{ dim: fab }"
                          >error</v-icon
                        >
                        <v-icon
                          color="success"
                          v-if="item.visit_status === 8"
                          :class="{ dim: fab }"
                          >home</v-icon
                        >
                        <v-icon
                          color="success"
                          v-if="item.visit_status === 12"
                          :class="{ dim: fab }"
                          >store</v-icon
                        >
                        <v-icon
                          color="error"
                          v-if="
                            item.visit_status === 5 ||
                            item.visit_status === 6 ||
                            item.visit_status === 7 ||
                            item.visit_status === 9 ||
                            item.visit_status === 10 ||
                            item.visit_status === 11 ||
                            item.visit_status === 13
                          "
                          :class="{ dim: fab }"
                        >
                          clear
                        </v-icon>
                        <div class="ml-2">
                          <p
                            style="
                              margin-bottom: 0px;
                              font-size: 13px;
                              font-weight: bold;
                            "
                          >
                            <span
                              v-if="item.visit_type.id === 4"
                              style="
                                font-size: 14px;
                                font-weight: bold;
                                border-radius: 12px;
                                background-color: #c8272a;
                                padding: 2px 6px;
                                color: white;
                              "
                            >
                              No Confirmada
                            </span>

                            <span v-else-if="item.visit_status === 8">
                              Servicio en curso
                            </span>
                            <span v-else>
                              {{ item.visit_status_name }}
                            </span>
                          </p>
                          <p
                            style="margin-bottom: 0; text-transform: capitalize"
                          >
                            {{ item.visit_date && formatDate(item.visit_date) }}
                          </p>
                          <p style="margin-bottom: 0">
                            de {{ item.arrival_time }} a
                            {{ item.departure_time }} hs
                          </p>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </template>

              <template
                v-else-if="currentTechReq.request.status_request.id != 13"
              >
                <v-col cols="12" class="pb0">
                  <h4>Servicios</h4>
                </v-col>
                <v-col cols="12" class="pb0">
                  <p>El pedido aún no tiene servicios</p>
                </v-col>
              </template>

              <!-- Budget information -->
              <BudgetsPreview :requestId="currentTechReq.request.id" />

              <!-- SELECT TIME SLOT -->
              <v-col
                cols="12"
                class="pb0"
                v-if="
                  currentTechReq &&
                  currentTechReq.request.status_request.id == 13 &&
                  currentVisit &&
                  currentVisit.visit_type.id !== 4
                "
              >
                <h4 style="color: #3a3a3a; font-size: 1rem">
                  {{ mobsUser ? "Servicio" : "Servicios" }}
                </h4>
              </v-col>

              <v-col
                cols="12"
                class="pt0"
                v-if="
                  currentTechReq &&
                  currentTechReq.request.status_request.id == 13
                "
              >
                <v-radio-group
                  style="margin: 0; font-size: 1rem"
                  :disabled="hasResponded"
                  v-model="selectedAvailability"
                >
                  <v-row
                    v-for="(item, i) in currentTechReq.request.availability"
                    :key="i"
                  >
                    <!-- Date -->
                    <v-col
                      cols="10"
                      md="10"
                      style="padding-bottom: 0"
                      class="
                        ml-2
                        d-flex
                        flex-row
                        justify-space-arround
                        align-center
                      "
                    >
                      <p
                        style="
                          margin: 0;
                          font-size: 0.9rem;
                          font-weight: 400;
                          color: #3a3a3a;
                        "
                      >
                        {{ getFormattedDate(item) }}
                      </p>

                      <!-- Radio button option -->
                      <v-radio
                        v-show="!mobsUser"
                        color="rapired"
                        :key="i"
                        :value="item.id"
                        class="ml-12"
                      ></v-radio>
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-col>

              <!-- Payment methods -->
              <v-col v-if="!mobsUser" cols="12" class="req__list">
                <h4 class="mb-2 ml-3">Métodos de pago</h4>
                <p
                  class="req__list_item"
                  v-for="(item, i) in currentTechReq.request.payment_methods"
                  :key="i"
                >
                  {{ item.name }}
                </p>
              </v-col>

              <!-- Diagnostic questions Cristopher-->
              <v-col 
                v-if="!mobsUser && 
                currentTechReq.request && 
                currentTechReq.request.diagnostic_questions" 
                cols="12" 
                class="req__list"
              > 
                <h4 class="mb-2 ml-3">Preguntas de diagnóstico</h4>
                <p class="req__list_item"
                  v-for="(item, i) in currentTechReq.request
                    .diagnostic_questions"
                  :key="i"
                >
                  <v-icon
                    color="success"
                    v-if="item.checked"
                    :class="{ dim: fab }"
                    >assignment_turned_in</v-icon
                  >
                  <v-icon color="error" v-else :class="{ dim: fab }"
                    >remove_done</v-icon
                  >
                  {{ item.question }}
                </p>
              </v-col>
            </v-row>
          </div>

          <!-- CHAT -->
          <!-- <div Cristopher
            v-if="!mobsUser"
            class="hidden-sm-and-down pt-8 pl-8"
            style="position: fixed; right: 0; top: 20px; width: 29%"
          >
            <v-card flat style="transition: 0.7s; border: 1px solid #e0e0e0">
              <div v-if="this.hasPermissionGranted">
                <ChatDetail compact />
              </div>
              <div
                v-else
                style="
                  height: 300mm;
                  background-color: #eeeeee;
                  padding-top: 5mm;
                  text-align: center;
                "
              >
                <h3>Debe permitir las notificaciones para ver el chat</h3>
              </div>
            </v-card>
          </div> -->
        </v-row>

        <!-- Buttons -->
        <div class="bottom-bar">
          <v-row align="center">
            <v-col class="mobile-btn" cols="6">
              <v-btn
                class="hidden-md-and-up state-service-btn"
                v-if="
                  currentVisit &&
                  currentVisit.visit_status == 1 &&
                  currentVisit.visit_type.id !== 4 &&
                  currentTechReq.request &&
                  currentTechReq.request.status_request &&
                  currentTechReq.request.status_request.id != 13
                "
                color="secondary"
                large
                @click="showCheckInConfirmDialog()"
                >{{ mobsUser ? "INICIAR SERVICIO" : "Check-in" }}</v-btn
              >
              <!-- En el boton FIN, agregue al v-if currentVisit.visit_status === 12 para que se vea, igual q finalizar servicio Cristopher -->
              <v-btn
                class="hidden-md-and-up state-service-btn"
                v-if="
                  currentVisit &&
                  (currentVisit.visit_status === 8 ||
                    currentVisit.visit_status === 12) &&
                  currentTechReq.request &&
                  currentTechReq.request.status_request &&
                  currentTechReq.request.status_request.id != 13
                "
                color="rapired"
                dark
                large
                @click="showCheckOutConfirmDialog()"
                >check-out</v-btn
              >
            </v-col>
            <!-- </v-row> no hacen falta Cristopher
          
          <v-row> -->
            <!-- btn mobile Cristopher -->
            <v-col class="interested-btn" cols="12">
              <v-btn
                class="hidden-md-and-up mb-3"
                style="width: 60%"
                v-if="showInterestedOptions"
                @click="iAmNotInterested"
                color="rapired"
                dark
                >No agendar</v-btn
              >

              <v-btn
                class="hidden-md-and-up"
                style="width: 60%"
                v-if="showInterestedOptions"
                @click="iAmInterested"
                :disabled="!selectedAvailability"
                color="secondary"
                >Agendar</v-btn
              >
            </v-col>
            <!-- btn mobile Cristopher -->

            <!-- btn desktop Cristopher -->
            <v-col cols="6" class="menu-container">
              <v-btn
                class="hidden-sm-and-down mr-6"
                v-if="showInterestedOptions"
                @click="iAmNotInterested"
                color="rapired"
                dark
                large
                >No agendar</v-btn
              >

              <v-btn
                class="hidden-sm-and-down"
                v-if="showInterestedOptions"
                @click="iAmInterested"
                :disabled="!selectedAvailability"
                color="secondary"
                large
                >Agendar</v-btn
              >
            </v-col>
            <!-- btn desktop Cristopher -->
            <!-- </v-row> rows no son necesarias Cristopher

          <v-row> -->
            <v-col>
              <div class="state-services-menu">
                <v-btn
                  class="hidden-sm-and-down mr-12 mt-1"
                  v-if="
                    currentVisit &&
                    currentVisit.visit_status == 1 &&
                    currentVisit.visit_type.id !== 4 &&
                    currentTechReq.request &&
                    currentTechReq.request.status_request &&
                    currentTechReq.request.status_request.id !== 13
                  "
                  color="secondary"
                  large
                  @click="showCheckInConfirmDialog()"
                  >{{ mobsUser ? "INICIAR SERVICIO" : "CHECK-IN" }}</v-btn
                >

                <v-btn
                  class="hidden-sm-and-down mr-12 mt-1"
                  v-if="
                    currentVisit &&
                    (currentVisit.visit_status === 8 ||
                      currentVisit.visit_status === 12) &&
                    currentTechReq.request &&
                    currentTechReq.request.status_request &&
                    currentTechReq.request.status_request.id != 13
                  "
                  color="rapired"
                  dark
                  large
                  @click="showCheckOutConfirmDialog()"
                  >{{ mobsUser ? "FINALIZAR SERVICIO" : "check-out" }}</v-btn
                >
                <v-speed-dial
                  style="justify-self: flex-end"
                  v-model="fab"
                  direction="top"
                  transition="slide-y-reverse-transition"
                  v-if="
                    currentTechReq &&
                    currentTechReq.request &&
                    currentTechReq.request.status_request &&
                    currentTechReq.request.status_request.id != 13 ||
                    currentVisit &&
                    currentVisit.visit_type.id !== 4 &&
                    currentVisit.visit_status !== 13 &&
                    currentVisit.visit_status !== 14
                  "
                >
                <!-- currentVisit.visit_status !== 12 && se saco para verse en curso Cristopher -->
                  <template v-slot:activator>
                    <v-btn v-model="fab" color="rapired" dark fab>
                      <v-icon v-if="fab">mdi-close</v-icon>
                      <v-icon v-else>menu</v-icon>
                    </v-btn>
                  </template>

                  <!-- <v-btn
                    v-if="!mobsUser && requestIsActive && currentVisit"
                    style="transform: translateX(-71px)"
                    color="#eeeeee"
                    class="ma-2"
                    rounded
                    large
                    @click="finalizeService"
                  >
                    Finalizar pedido
                    <v-icon right dark>clear</v-icon>
                  </v-btn> -->

                  <v-btn
                    v-if="
                      requestHasPendingVisit ||
                      (currentVisit && currentVisit.visit_status === 12) 
                    "
                    v-show="currentVisit && currentVisit.visit_status !== 1"
                    style="transform: translateX(-68px)"
                    color="#eeeeee"
                    class="ma-2"
                    rounded
                    large
                    @click="cancelVisitDialog = true"
                  >
                    {{ mobsUser ? "Cancelar Servicio" : "Cancelar visita" }}
                    <v-icon right dark>clear</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="
                      !mobsUser && requestIsActive && requestHasPendingVisit && currentVisit.visit_status != 1
                    "
                    style="transform: translateX(-58px)"
                    color="#eeeeee"
                    class="ma-2"
                    rounded
                    large
                    @click="rescheduleVisitDialog = true"
                  >
                    Reprogramar
                    <v-icon right dark>access_time</v-icon>
                  </v-btn>

                  <!-- <v-btn
                    v-if="
                      !mobsUser &&
                      requestIsActive &&
                      !requestHasPendingVisit &&
                      !isNewOpportunity
                    "
                    style="transform: translateX(-64px)"
                    color="#eeeeee"
                    class="ma-2"
                    rounded
                    large
                    @click="scheduleNewVisitDialog = true"
                  >
                    Agendar visita
                    <v-icon right dark>access_time</v-icon>
                  </v-btn> -->

                  <v-btn
                    v-if="!mobsUser && requestHasPendingVisit"
                    style="transform: translateX(-55px)"
                    color="#eeeeee"
                    class="ma-2"
                    rounded
                    large
                    @click="noAnswerDialog = true"
                  >
                    No hay nadie
                    <v-icon right dark>error_outline</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="requestHasPendingVisit"
                    style="transform: translateX(-84px)"
                    color="#eeeeee"
                    class="ma-2"
                    rounded
                    large
                    @click="delayedArrivalDialog = true"
                  >
                    Horario de llegada
                    <v-icon right dark>timer</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="!mobsUser && !isNewOpportunity"
                    style="transform: translateX(-60px)"
                    color="#eeeeee"
                    class="ma-2"
                    rounded
                    large
                    @click="
                      $router.push({
                        name: 'budget-list',
                        query: { requestId: currentTechReq.request.id },
                      })
                    "
                  >
                    Presupuestos
                    <v-icon right dark>attach_money</v-icon>
                  </v-btn>

                  <!-- <v-btn
                    v-if="!mobsUser && showChargesOption"
                    style="transform: translateX(-31px)"
                    color="#eeeeee"
                    class="ma-2"
                    rounded
                    large
                    @click="
                      $router.push({
                        name: 'charge-list',
                        query: {
                          requestId: currentTechReq.request.id,
                        },
                      })
                    "
                  >
                    Cobros
                    <v-icon right dark>attach_money</v-icon>
                  </v-btn> -->

                  <v-btn
                    v-if="!mobsUser"
                    style="transform: translateX(-33px)"
                    color="#eeeeee"
                    class="ma-2"
                    rounded
                    large
                    @click="galleryDialog = true"
                  >
                    Galería
                    <v-icon right dark>collections</v-icon>
                  </v-btn>

                  <!-- <v-btn Cristopher
                    v-if="!mobsUser"
                    style="transform: translateX(-21px)"
                    color="#eeeeee"
                    class="ma-2 hidden-md-and-up"
                    rounded
                    large
                    @click="
                      $router.push({
                        name: 'chat-detail',
                        query: {
                          requestId: currentTechReq.request.id,
                        },
                      })
                    "
                    >Chat
                    <v-icon right dark>comment</v-icon>
                  </v-btn> -->
                </v-speed-dial>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-card>

    <ConfirmCheckInDialog
      v-if="checkInDialog"
      :show="checkInDialog"
      @close-dialog="checkInDialog = false"
      @confirm-checkin="checkIn"
    />
    <ConfirmCheckOutDialog
      v-if="checkOutDialog"
      :show="checkOutDialog"
      @close-dialog="checkOutDialog = false"
      @endmetting-dialog="endMeetingDialog = true"
    />
    <AppGallery
      v-if="galleryDialog"
      :show="galleryDialog"
      :noAnswer="noAnswer"
      :gallery="currentTechReq.request.gallery"
      :requestId="currentTechReq.request.id"
      @reload-request="loadRequestFromAPI"
      @close-dialog="galleryDialog = false"
    />
    <DelayedArrivalDialog
      v-if="delayedArrivalDialog"
      :show="delayedArrivalDialog"
      :requestId="currentTechReq.request.id"
      :requestAddress="currentTechReq.request.full_address"
      :visitId="currentVisit.id"
      @close-dialog="delayedArrivalDialog = false"
    />
    <ScheduleNewVisitDialog
      v-if="scheduleNewVisitDialog"
      :show="scheduleNewVisitDialog"
      :requestId="currentTechReq.request.id"
      :techReqId="currentTechReq.id"
      :requestAddress="currentTechReq.request.full_address"
      :onPremises="currentVisit ? currentVisit.on_premises : null"
      :serviceId="currentTechReq.request.service.id"
      @visit-scheduled="scheduleVisit"
      @close-dialog="scheduleNewVisitDialog = false"
    />
    <RescheduleVisitDialog
      v-if="rescheduleVisitDialog"
      :show="rescheduleVisitDialog"
      :requestId="currentTechReq.request.id"
      :requestAddress="currentTechReq.request.full_address"
      :visitId="currentVisit.id"
      :onPremises="currentVisit.on_premises"
      :serviceId="currentTechReq.request.service.id"
      @reload-request="loadRequestFromAPI"
      @close-dialog="rescheduleVisitDialog = false"
    />
    <NoAnswerDialog
      v-if="noAnswerDialog"
      :show="noAnswerDialog"
      @close-dialog="noAnswerDialog = false"
      @confirm-noanswer="confirmNoAnswer"
    />
    <end-meeting-dialog
      v-if="endMeetingDialog"
      :show="endMeetingDialog"
      :visit="currentVisit"
      :request="currentTechReq"
      @close-dialog="endMeetingDialog = false"
      @reload-request="loadRequestFromAPI"
    />

    <FinalizeServiceDialog
      v-if="finalizeServiceDialog"
      :show="finalizeServiceDialog"
      :requestId="currentTechReq.request.id"
      :visitId="currentVisit.id"
      @reload-request="loadRequestFromAPI"
      @close-dialog="finalizeServiceDialog = false"
    />

    <CancelVisitDialog
      v-if="cancelVisitDialog"
      :show="cancelVisitDialog"
      :visitId="currentVisit.id"
      @reload-request="delayedLoadRequestFromAPI"
      @close-dialog="cancelVisitDialog = false"
    />
  </section>
</template>

<script>
import moment from "moment";
import BudgetsPreview from "./BudgetsPreview";
import AppGallery from "./AppGallery";
import ConfirmCheckInDialog from "./ConfirmCheckInDialog";
import ConfirmCheckOutDialog from "./ConfirmCheckOutDialog";
import DelayedArrivalDialog from "./DelayedArrivalDialog";
import ScheduleNewVisitDialog from "./ScheduleNewVisitDialog";
import RescheduleVisitDialog from "./RescheduleVisitDialog";
import FinalizeServiceDialog from "./FinalizeServiceDialog";
import NoAnswerDialog from "./NoAnswerDialog";
import CancelVisitDialog from "./CancelVisitDialog";
import Loader from "./Loader";
// import ChatDetail from "./ChatDetail";
import EndMeetingDialog from "./Mobs/EndMeetingDialog.vue";

export default {
  components: {
    AppGallery,
    BudgetsPreview,
    ConfirmCheckInDialog,
    ConfirmCheckOutDialog,
    DelayedArrivalDialog,
    ScheduleNewVisitDialog,
    RescheduleVisitDialog,
    FinalizeServiceDialog,
    CancelVisitDialog,
    NoAnswerDialog,
    // ChatDetail,
    Loader,
    EndMeetingDialog,
  },

  data: () => ({
    selectedAvailability: null,
    galleryDialog: false,
    delayedArrivalDialog: false,
    scheduleNewVisitDialog: false,
    rescheduleVisitDialog: false,
    endMeetingDialog: false,
    finalizeServiceDialog: false,
    cancelVisitDialog: false,
    fab: false,
    requestVisits: null,
    currentVisit: null,
    currentTechReq: null,
    checkInDialog: false,
    checkOutDialog: false,
    noAnswerDialog: false,
    noAnswer: false,
  }),

  computed: {
    mobsUser() {
      return this.$store.state.mobsUser;
    },

    originAddress() {
      return this.currentTechReq.request.same_address
        ? this.currentTechReq.request.address_request.full_address
        : this.currentTechReq.request.address_client.full_address;
    },

    requirementFilter() {
      const requirements =
        this.currentTechReq.request.diagnostic_questions.filter(
          (item) => item.checked         
        );
      return requirements;
    },

    userTechReqs() {
      return this.$store.state.user_techReqs;
    },

    currentUser() {
      return this.$store.state.current_techReq;
    },

    checkTimeSlot() {
        return this.selectedAvailability 
    },

    checkStatus() {
      if (this.mobsUser && this.currentTechReq.visit.length > 0) {
        return `${this.currentTechReq.visit[0].visit_type.label} ${this.currentTechReq.visit[0].visit_status_name}`;
      } else {
        return `${this.currentTechReq.request.status_request.description}`;
      }
    },

    showInterestedOptions: function () {
      if (
        this.currentTechReq &&
        this.currentTechReq.request &&
        this.currentTechReq.request.status_request &&
        this.currentTechReq.request.status_request.id &&
        this.currentTechReq.request.status_request.id == 13 &&
        this.currentTechReq.respuesta &&
        this.currentTechReq.respuesta == 1
      )
        return true;
      return false;
    },

    hasResponded: function () {
      return (
        this.currentTechReq.respuesta && this.currentTechReq.respuesta != 1
      );
    },

    showVisits: function () {
      if (
        this.currentTechReq.request &&
        this.currentTechReq.request.status_request &&
        this.currentTechReq.request.status_request.id === 13
      ) {
        switch (this.currentTechReq.respuesta) {
          case 1:
            return false;
          case 2:
            return true;
          case 3:
            return false;
        }
      }
      return !!this.currentTechReq.visit.length;
    },

    requestsAreLoaded: function () {
      return this.userTechReqs.length > 0 ? true : false;
    },

    googleMapsLink: function () {
      return (
        "https://www.google.com/maps/search/?api=1&query=" +
        this.currentTechReq.request.address_request.maps_address +
        "%20"
      );
    },
    googleMapsLinkClient: function () {
      return (
        "https://www.google.com/maps/search/?api=1&query=" +
        this.currentTechReq.request.address_client.maps_address +
        "%20" 
      );
    },

    requestHasPendingVisit: function () {
      if (this.requestVisits == null) return false;
      const pendingVisit = this.requestVisits.find(
        (visit) => visit.visit_status === 1
      );
      if (pendingVisit) {
        return true;
      } else {
        return false;
      }
    },

    requestIsActive: function () {
      if (
        this.currentTechReq &&
        this.currentTechReq.request &&
        this.currentTechReq.request.status_request &&
        (this.currentTechReq.request.status_request.id === 10 ||
          this.currentTechReq.request.status_request.id === 11 ||
          this.currentTechReq.request.status_request.id === 12 ||
          this.currentTechReq.request.status_request.id === 13)
      ) {
        return true;
      } else {
        return false;
      }
    },

    isNewOpportunity: function () {
      if (
        this.currentTechReq &&
        this.currentTechReq.request &&
        this.currentTechReq.request.status_request &&
        this.currentTechReq.request.status_request.id === 13
      ) {
        return true;
      } else {
        return false;
      }
    },

    showChargesOption: function () {
      if (
        this.requestVisits &&
        this.requestVisits.some(
          ({ visit_status }) => visit_status === 2 || visit_status === 8
        )
      ) {
        return true;
      } else {
        return false;
      }
    },

    hasPermissionGranted() {
      return Notification.permission === "granted";
    },
  },

  methods: {
    getPreviouslySelectedAvailability: function () {
      const result = this.currentTechReq.request.availability.find(
        (item) =>
          item.time_from.slice(0, 10) == this.requestVisits[0].visit_date &&
          item.time_from.slice(11, 16) == this.requestVisits[0].arrival_time
      );
      this.selectedAvailability = result.id;
    },

    getFormattedDate(av) {
      if (av.time_from) {
        const from = moment(av.time_from);
        const to = moment(av.time_to);
        let formatted = "Desde" + " " + from.format("dddd DD MMMM");
        formatted +=
          " " +
          from.format("HH:mm") +
          " hs" +
          ", " +
          " Hasta " +
          from.format("dddd DD MMMM") +
          " " +
          to.format("HH:mm") +
          " hs";
        return formatted;
      }
    },

    loadRequestFromStore() {
      this.$store.commit("set_loading_request_detail", true);

      this.currentTechReq = this.userTechReqs.find(
        (techReq) => techReq.request.id === Number(this.$route.query.requestId)
      );

      this.currentTechReq &&
        localStorage.setItem("provider", this.currentTechReq.id);

      this.currentTechReq &&
        localStorage.setItem("provider", this.currentTechReq.id);

      this.currentTechReq
        ? (this.requestVisits = this.currentTechReq.visit)
        : (this.requestVisits = []);

      this.currentVisit = this.requestVisits.find(
        (visit) => visit.visit_status === 1
      );

      !this.currentVisit &&
        (this.currentVisit = this.requestVisits.find(
          (visit) => visit.visit_status === 8
        ));

      !this.currentVisit &&
        this.requestVisits.length > 0 &&
        (this.currentVisit = this.requestVisits[0]);

      this.currentTechReq &&
        this.setAppTitle(this.currentTechReq.request.display_id);

      this.isNewOpportunity &&
        this.hasResponded &&
        this.currentTechReq.respuesta == 2 &&
        this.getPreviouslySelectedAvailability();

      this.$store.commit("set_current_visit", this.currentVisit);
      this.$store.commit("set_current_techReq", this.currentTechReq);

      this.$store.commit("set_loading_request_detail", false);
    },

    formatDate(date) {
      const _date = new Date();
      const today = moment(_date).format("YYYY-MM-DD");
      if (date === today) {
        return "Hoy";
      } else {
        return moment(date, "YYYY-MM-DD").format("dddd DD MMMM, YYYY");
      }
    },

    showCheckInConfirmDialog() {
      this.checkInDialog = true;
    },

    showCheckOutConfirmDialog() {
      if (this.mobsUser) {
        this.checkOutDialog = true;
      } else {
        this.endMeetingDialog = true;
      }
    },

    checkIn() {
      const id = this.mobsUser ? 15 : 10;
      const body = { id: id, on_premises: true };
      this.axios
        .post(`/visit/${this.currentVisit.id}/status/`, body)
        .then((_) => {
          this.loadRequestFromAPI();
        });
    },

    checkOut() {
      const body = { id: 13 };
      this.axios
        .post(`/visit/${this.currentVisit.id}/status/`, body)
        .then((_) => {
          this.loadRequestFromAPI();
        });
    },

    confirmNoAnswer() {
      const body = { id: 2 };
      this.axios
        .post(`visit/${this.currentVisit.id}/status/`, body)
        .then((_) => {
          this.noAnswer = true;
          this.galleryDialog = true;
        })
        .catch((error) => {
          alert("Ha ocurrido un error");
        });
    },

    delayedLoadRequestFromAPI() {
      setTimeout(() => this.loadRequestFromAPI(), 1500);
    },

    loadRequestFromAPI() {
      this.$store.commit("set_loading_request_detail", true);

      const technician = Number(localStorage.getItem("provider"));

      this.axios
        .get(`/request_technician/${technician}/`)
        .then((response) => {
          this.currentTechReq = response.data;
          this.requestVisits = this.currentTechReq.visit;

          this.currentVisit = this.requestVisits.find(
            (visit) => visit.visit_status === 1
          );

          if (!this.currentVisit) {
            this.currentVisit = this.requestVisits.find(
              (visit) => visit.visit_status === 8
            );
          }

          if (!this.currentVisit && this.requestVisits.length) {
            this.currentVisit = this.requestVisits[0];
          }

          if (this.currentTechReq.request.external_id) {
            const displayId =
              this.currentTechReq.request.id +
              " (" +
              this.currentTechReq.request.external_id +
              ")";
            this.currentTechReq.request = {
              ...this.currentTechReq.request,
              display_id: displayId,
            };
          } else {
            this.currentTechReq.request = {
              ...this.currentTechReq.request,
              display_id: this.currentTechReq.request.id,
            };
          }

          this.isNewOpportunity &&
            this.hasResponded &&
            this.currentTechReq.respuesta == 2 &&
            this.getPreviouslySelectedAvailability();

          this.currentTechReq &&
            this.setAppTitle(this.currentTechReq.request.display_id);
          this.$store.commit("set_current_visit", this.currentVisit);
          this.currentTechReq &&
            this.$store.commit("set_current_techReq", this.currentTechReq);
          this.currentTechReq &&
            this.$store.commit("updateCachedTechReq", this.currentTechReq);
          this.$store.commit("set_loading_request_detail", false);
        })
        .catch(() => {
          this.$store.commit("set_loading_request_detail", false);
        });
    },

    setAppTitle(title) {
      this.$store.commit("set_app_title", `#${title}`);
    },

    scheduleVisit() {
      this.loadRequestFromAPI();
    },

    finalizeService() {
      this.finalizeServiceDialog = true;
    },

    iAmInterested() {
      const body = {
        reply: true,
        availability: this.selectedAvailability,
      };

      const { id } = this.currentTechReq;

      id &&
        this.axios.put(`request_technician/${id}/reply/`, body).then((_) => {
          this.$route.params &&
            this.$route.params.notificationId &&
            this.axios.delete(
              `notification/${this.$route.params.notificationId}/`
            );
          this.$store.commit("show_alert", "Se ha marcado como Interesado");
          this.loadRequestFromAPI();
        });
    },

    iAmNotInterested() {
      const body = {
        reply: false,
      };
      const { id } = this.currentTechReq;

      id &&
        this.axios.put(`request_technician/${id}/reply/`, body).then((_) => {
          this.$route.params &&
            this.$route.params.notificationId &&
            this.axios.delete(
              `notification/${this.$route.params.notificationId}/`
            );
          this.$store.commit("show_alert", "Se ha marcado como No Interesado");
          this.loadRequestFromAPI();
          this.$router.push("notification-list");
        });
    },
  },

  mounted() {
    if(this.requestsAreLoaded) {
      this.loadRequestFromStore()
    }
  },

  watch: {
    mobsUser(val) {
      if (val) {
        this.selectedAvailability = this.currentTechReq.request.availability[0].id
      }
    },

    "$store.state.user_techReqs": function (val) {
      console.log({ desde_request: val });
      this.loadRequestFromStore();
    },

    "$store.state.reload_request": function (val) {
      if (val === true) {
        this.$store.commit("reload_request", false);
        this.loadRequestFromAPI();
      }
    },
  },
};
</script>

<style scoped>
/* se quito de finzaliar servicio mobile porque se agrego cancelar servicio Cristopher
.end-btn {
  position: relative;
  left: 6rem;
} */
.success-text {
  color: green;
}
.icon-details{
  width: 25px;
}

.interested-btn {
  position: relative;
  bottom: 3.5rem;
}
@media (max-width: 600px) {
  .interested-btn > .v-btn {
    width: 90% !important;
  }
}
@media (max-width: 420px) {
  .state-services-menu {
    right: 6rem;
  }
  .state-service-btn {
    left: 2rem;
  }
  
}

img {
  width: 2%;
}
.state-services-menu {
  position: fixed;
  bottom: 1.5rem;
  display: flex;
}
.bottom-bar {
  position: fixed;
  display: flex;
  padding: 0 24px;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
}
.v-speed-dial {
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 959px) {
  img {
    width: 5%;
  }
  .mobile-btn {
    display: flex;
    justify-content: flex-end;
    padding-top: 1.5rem;
  }
  .bottom-bar {
    padding: 0 24px;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
  }
  .overlay {
    background: #424242;
    opacity: 0.7;
  }
  .dim {
    opacity: 0.3;
  }
  .visit {
    border-bottom: 1px solid lightgrey;
    padding: 0px;
  }
  .left-col {
    width: 100%;
  }
}
@media (min-width: 960px) {
  .dim {
    opacity: 0.3;
  }
  /* si se comenta el .bottom-bar se mueve todo mas a la derecha Cristopher */
  /* .bottom-bar {
    position: fixed;
    padding: 0 24px;
    bottom: 0;
    left: 0;
    width: 73%;
    height: 100px;
  } */
  .left-col {
    width: 65%;
  }
  .close-icon-container {
    display: flex;
    justify-content: flex-end;
  }
  .regular {
    background: #eeeeee;
  }
  .visit {
    padding: 12px;
  }
  .fix-desk {
    transform: translateX(260px);
  }
  .overlay {
    background: #424242;
    opacity: 0.7;
  }
}
.left-col {
  transition: 1s;
}
.highlighted {
  background: #e1f5fe;
}

.menu-container {
  padding: 0;
  display: flex;
  justify-content: flex-end;
}
.bodypad {
  padding: 12px 24px 108px 24px;
}
.pb0 {
  padding-bottom: 0;
}
.pt0 {
  padding-top: 0;
}
.p0 {
  padding: 0;
}
.m0 {
  margin: 0;
}
.in-bl {
  display: inline-block;
}
.icon-cont {
  display: flex;
  justify-content: flex-end;
}
.fab-but-cont {
  display: flex;
  justify-content: flex-start;
}
.loader-container {
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.urgent {
  background-color: rgba(255, 251, 203, 0.5) !important;
}

.req__list {
  display: flex;
  padding: 0;
  justify-content: center;
  align-content: center;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 0.5rem;
  font-size: 1rem;
  color: #3a3a3a;
}
.req__list_item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.9rem;
  font-weight: bold;
  margin-left: 1.2rem;
  font-weight: 400;
}

.v-application p {
  margin-bottom: 0px;
}
</style>